import {
    getPrimaryMailboxSearchScopeKey,
    getArchiveMailboxSearchScopeKey,
    getSharedFoldersSearchScopeKey,
    getSingleGroupSearchScopeKey,
    getCalendarSearchScopeKey,
    getPublicFolderSearchScopeKey,
} from './getSearchScopeKey';
import {
    getPrimaryMailboxSearchScopeType,
    getArchiveMailboxSearchScopeType,
    getSharedFoldersSearchScopeType,
    getSingleGroupSearchScopeType,
    getCalendarSearchScopeType,
    getPublicFolderSearchScopeType,
} from './getSearchScopeType';
import { SearchScope, SearchScopeKind } from '../../data/schema/SearchScope';
import type BaseSearchScopeType from 'owa-service/lib/contract/BaseSearchScopeType';
import {
    getPrimaryMailboxSearchScopeList,
    getArchiveMailboxSearchScopeList,
    getSharedFoldersScopeList,
    getGroupSearchScopeList,
    getCalendarSearchScopeList,
    getPublicFolderSearchScopeList,
} from './getSearchScopeList';

interface SearchScenario {
    // Gets the Unique Key related a given SearchScope
    getKey: (scope: SearchScope) => string;

    // Gets the SearchScope list used for the current scope scenario
    getSearchScopeList: () => SearchScope[];

    // Gets the BaseSearchScopeType object used for the search request for a given SearchScope
    getSearchScopeType: (scope: SearchScope) => BaseSearchScopeType[];
}

const primaryMailboxScenario: SearchScenario = {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (43,5): Type '(primaryMailboxSearchScope: PrimaryMailboxSearchScope) => string' is not assignable to type '(scope: SearchScope) => string'.
    // @ts-expect-error
    getKey: getPrimaryMailboxSearchScopeKey,
    getSearchScopeList: getPrimaryMailboxSearchScopeList,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (48,5): Type '(primaryMailboxSearchScope: PrimaryMailboxSearchScope) => BaseSearchScopeType[]' is not assignable to type '(scope: SearchScope) => BaseSearchScopeType[]'.
    // @ts-expect-error
    getSearchScopeType: getPrimaryMailboxSearchScopeType,
};

const archiveMailboxScenario: SearchScenario = {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (55,5): Type '(archiveMailboxSearchScope: ArchiveMailboxSearchScope) => string' is not assignable to type '(scope: SearchScope) => string'.
    // @ts-expect-error
    getKey: getArchiveMailboxSearchScopeKey,
    getSearchScopeList: getArchiveMailboxSearchScopeList,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (60,5): Type '(archiveMailboxSearchScope: ArchiveMailboxSearchScope) => BaseSearchScopeType[]' is not assignable to type '(scope: SearchScope) => BaseSearchScopeType[]'.
    // @ts-expect-error
    getSearchScopeType: getArchiveMailboxSearchScopeType,
};

const sharedFoldersScenario: SearchScenario = {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (67,5): Type '(sharedFoldersSearchScope: SharedFoldersSearchScope) => string' is not assignable to type '(scope: SearchScope) => string'.
    // @ts-expect-error
    getKey: getSharedFoldersSearchScopeKey,
    getSearchScopeList: getSharedFoldersScopeList,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (72,5): Type '(sharedFoldersSearchScope: SharedFoldersSearchScope) => BaseSearchScopeType[]' is not assignable to type '(scope: SearchScope) => BaseSearchScopeType[]'.
    // @ts-expect-error
    getSearchScopeType: getSharedFoldersSearchScopeType,
};

const groupScenario: SearchScenario = {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (79,5): Type '(singleGroupSearchScope: SingleGroupSearchScope) => string' is not assignable to type '(scope: SearchScope) => string'.
    // @ts-expect-error
    getKey: getSingleGroupSearchScopeKey,
    getSearchScopeList: getGroupSearchScopeList,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (84,5): Type '(singleGroupSearchScope: SingleGroupSearchScope) => BaseSearchScopeType[]' is not assignable to type '(scope: SearchScope) => BaseSearchScopeType[]'.
    // @ts-expect-error
    getSearchScopeType: getSingleGroupSearchScopeType,
};

const calendarScenario: SearchScenario = {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (91,5): Type '(calendarSearchScope: CalendarSearchScope) => string' is not assignable to type '(scope: SearchScope) => string'.
    // @ts-expect-error
    getKey: getCalendarSearchScopeKey,
    getSearchScopeList: getCalendarSearchScopeList,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (96,5): Type '(calendarSearchScope: CalendarSearchScope) => BaseSearchScopeType[]' is not assignable to type '(scope: SearchScope) => BaseSearchScopeType[]'.
    // @ts-expect-error
    getSearchScopeType: getCalendarSearchScopeType,
};

const publicFolderScenario: SearchScenario = {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (103,5): Type '(publicFolderSearchScope: PublicFolderSearchScope) => string' is not assignable to type '(scope: SearchScope) => string'.
    // @ts-expect-error
    getKey: getPublicFolderSearchScopeKey,
    getSearchScopeList: getPublicFolderSearchScopeList,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (108,5): Type '(publicFolderSearchScope: PublicFolderSearchScope) => BaseSearchScopeType[]' is not assignable to type '(scope: SearchScope) => BaseSearchScopeType[]'.
    // @ts-expect-error
    getSearchScopeType: getPublicFolderSearchScopeType,
};

const pickScenario = (scope: SearchScope) => {
    switch (scope.kind) {
        case SearchScopeKind.PrimaryMailbox:
            return primaryMailboxScenario;
        case SearchScopeKind.ArchiveMailbox:
            return archiveMailboxScenario;
        case SearchScopeKind.SharedFolders:
            return sharedFoldersScenario;
        case SearchScopeKind.Group:
            return groupScenario;
        case SearchScopeKind.Calendar:
            return calendarScenario;
        case SearchScopeKind.PublicFolder:
            return publicFolderScenario;

        default:
            throw new Error('Unregistered search scope');
    }
};

export const getKey = (scope: SearchScope) => pickScenario(scope).getKey(scope);
export const getSearchScopeList = (scope: SearchScope) => pickScenario(scope).getSearchScopeList();
export const getSearchScopeType = (scope: SearchScope) =>
    pickScenario(scope).getSearchScopeType(scope);
